import axios from 'axios';
import {
  collection,
  doc,
  getDoc,
  getFirestore,
  setDoc,
} from 'firebase/firestore';
import { useCallback, useEffect, useState } from 'react';
import './styles.css';
const SenderForm = () => {
  const [senderData, setSenderData] = useState({
    name: '',
    surname: '',
    phone: '',
    city: {},
    warehouse: {},
  });
  const [senderEditingData, setSenderEditingData] = useState({
    name: '',
    surname: '',
    phone: '',
    city: {},
    warehouse: {},
  });

  const [cities, setCities] = useState([]);
  const [warehouses, setWarehouses] = useState([]);
  const [isEditingMode, setIsEditingMode] = useState(false);
  const [searchCity, setSearchCity] = useState('');
  const [searchWarehouse, setSearchWarehouse] = useState('');
  const db = getFirestore();
  const NOVA_POST_API_KEY = process.env.NOVA_POST_KEY;
  const fetchSenderData = useCallback(async () => {
    try {
      const senderRef = doc(collection(db, 'delivery'), 'senderData');
      const snapshot = await getDoc(senderRef);

      if (snapshot.exists()) {
        const data = snapshot.data();
        setSenderData(data);
        setSenderEditingData(data);
        setSearchCity(data?.city?.Description);
        setSearchWarehouse(data.warehouse?.Description);
      }
    } catch (error) {
      console.error('Error fetching sender data:', error);
    }
  }, [db]);
  useEffect(() => {
    fetchSenderData();
  }, [fetchSenderData]);
  const fetchCities = async (query) => {
    try {
      const response = await axios.post(
        'https://api.novaposhta.ua/v2.0/json/',
        {
          apiKey: NOVA_POST_API_KEY,
          modelName: 'Address',
          calledMethod: 'getSettlements',
          methodProperties: {
            FindByString: query,
            Limit: 20,
          },
        }
      );

      if (response.data.success) {
        setCities(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching cities:', error);
    }
  };

  const fetchWarehouses = async (query = '') => {
    try {
      const response = await axios.post(
        'https://api.novaposhta.ua/v2.0/json/',
        {
          apiKey: NOVA_POST_API_KEY,
          modelName: 'Address',
          calledMethod: 'getWarehouses',
          methodProperties: {
            SettlementRef: senderEditingData.city.Ref,
            FindByString: query,
            Limit: 20,
          },
        }
      );

      if (response.data.success) {
        setWarehouses(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching warehouses:', error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSenderEditingData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Валідація даних
    const { name, surname, phone, city, warehouse } = senderEditingData;

    // Перевірка довжини імені та прізвища
    if (name.length < 3 || surname.length < 3) {
      alert("Ім'я та прізвище повинні бути не коротшими за 3 символи");
      return;
    }

    const phoneRegex = /^(\+?380|380|0)\d{9}$/;

    if (!phoneRegex.test(phone)) {
      alert('Неправильний формат номера телефону');
      return;
    }
    if (!city.Ref || !warehouse.Ref) {
      alert('Оберіть місто та відділення');
      return;
    }

    try {
      const senderRef = doc(collection(db, 'delivery'), 'senderData');
      await setDoc(senderRef, senderEditingData);
      alert('Дані про відправника успішно збережено!');
      setIsEditingMode(!isEditingMode);
    } catch (error) {
      console.error('Error saving sender data:', error);
    }
  };

  const [debounceTimer, setDebounceTimer] = useState(null);

  const handleSearchCity = (e) => {
    const query = e.target.value;
    setSearchCity(query);

    if (debounceTimer) {
      clearTimeout(debounceTimer);
    }

    if (query.length >= 2) {
      const timer = setTimeout(() => {
        fetchCities(query);
      }, 1000);
      setDebounceTimer(timer);
    } else {
      setCities([]);
    }
  };

  const handleSearchWarehouse = (e) => {
    const query = e.target.value;
    setSearchWarehouse(query);

    if (debounceTimer) {
      clearTimeout(debounceTimer);
    }

    if (query.length >= 2) {
      const timer = setTimeout(() => {
        fetchWarehouses(query);
      }, 1000);
      setDebounceTimer(timer);
    } else {
      setWarehouses([]);
    }
  };

  useEffect(() => {
    return () => {
      if (debounceTimer) {
        clearTimeout(debounceTimer);
      }
    };
  }, [debounceTimer]);
  return (
    <div className='sender-form'>
      <h2>Дані про відправника</h2>
      <form onSubmit={handleSubmit}>
        {!isEditingMode ? (
          <div>
            <div className='field'>
              <label>Ім'я:</label>
              <span> {senderData.name}</span>
            </div>
            <div className='field'>
              <label>Прізвище:</label>
              <span> {senderData.surname}</span>
            </div>
            <div className='field'>
              <label>Телефон:</label>
              <span> {senderData.phone}</span>
            </div>
            <div className='field'>
              <label>Місто:</label>
              <span> {senderData.city?.Description}</span>
            </div>
            <div className='field'>
              <label>Відділення:</label>
              <span> {senderData.warehouse?.Description}</span>
            </div>
          </div>
        ) : (
          <div className='edit-mode'>
            <div className='field'>
              <label>Ім'я:</label>
              <input
                type='text'
                name='name'
                value={senderEditingData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className='field'>
              <label>Прізвище:</label>
              <input
                type='text'
                name='surname'
                value={senderEditingData.surname}
                onChange={handleChange}
                required
              />
            </div>
            <div className='field'>
              <label>Телефон:</label>
              <input
                type='tel'
                name='phone'
                value={senderEditingData.phone}
                onChange={handleChange}
                required
              />
            </div>
            <div className='field'>
              <label>Місто:</label>
              <input
                type='text'
                placeholder='Введіть назву міста...'
                value={searchCity}
                onChange={handleSearchCity}
                required
              />
              {cities.length > 0 && (
                <ul className='dropdown'>
                  {cities.map((city) => (
                    <li
                      key={city.Ref}
                      onClick={() => {
                        setSenderEditingData((prev) => ({
                          ...prev,
                          city: city,
                        }));
                        setSearchCity(
                          ` ${
                            city.SettlementTypeDescription &&
                            `${city.SettlementTypeDescription} `
                          }${city.Description}${
                            city.AreaDescription &&
                            `, ${city.AreaDescription} область`
                          }${
                            city.RegionsDescription &&
                            `, ${city.RegionsDescription} р-н`
                          }`
                        );
                        setCities([]);
                      }}
                    >
                      {city.SettlementTypeDescription &&
                        `${city.SettlementTypeDescription} `}
                      {city.Description}
                      {city.AreaDescription &&
                        `, ${city.AreaDescription} область`}
                      {city.RegionsDescription &&
                        `, ${city.RegionsDescription} р-н`}
                    </li>
                  ))}
                </ul>
              )}
            </div>
            <div className='field'>
              <label>Відділення:</label>
              <input
                type='text'
                placeholder='Введіть назву відділення...'
                value={searchWarehouse}
                onChange={handleSearchWarehouse}
                required
              />
              {warehouses.length > 0 && (
                <ul className='dropdown'>
                  {warehouses.map((warehouse) => (
                    <li
                      key={warehouse.Ref}
                      onClick={() => {
                        setSenderEditingData((prev) => ({
                          ...prev,
                          warehouse: warehouse,
                        }));
                        setSearchWarehouse(warehouse.Description);
                        setWarehouses([]);
                      }}
                    >
                      {warehouse.Description}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        )}

        <div className='controls'>
          <button
            type='button'
            onClick={() => {
              setSenderEditingData(senderData);
              setIsEditingMode(!isEditingMode);
            }}
          >
            {!isEditingMode ? 'Редагувати' : 'Скасувати'}
          </button>
          {isEditingMode && <button type='submit'>Зберегти</button>}
        </div>
      </form>
    </div>
  );
};

export default SenderForm;
